import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {formatter, toFixed} from 'helpers';

const CurrencyValue = ({currencySymbol, value}) => (
  <span>
    {(value || value === 0) && currencySymbol}
    {typeof value === 'number'
      ? formatter.formatNumber(toFixed(value, 2))
      : value}
  </span>
);

CurrencyValue.defaultProps = {
  override: null,
  value: '',
};

CurrencyValue.propTypes = {
  currencySymbol: PropTypes.string.isRequired,
  override: PropTypes.string,
  value: PropTypes.any,
};

const mapStateToProps = (state, props) => ({
  currencySymbol: props.override
    ? props.override
    : state.portal.dictionary && state.portal.dictionary.Currency
      ? state.portal.dictionary.Currency.value
      : '',
});

export default connect(mapStateToProps)(CurrencyValue);



// WEBPACK FOOTER //
// ./src/components/Common/Format/CurrencyValue.js